import {
    switchMap,
    distinctUntilChanged,
    debounceTime,
    filter,
    tap,
} from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import {
    AfterViewInit,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
} from '@angular/core';

import {
    GraphQlService,
    Location,
    SessionService,
    Trainer,
    TrainerService,
} from '../../_services';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';

@Component({
    selector: 'jhi-trainers',
    templateUrl: 'trainer.component.html',
    styleUrls: [
        'trainer.component.scss',
        '../_shared/label/label.component.scss',
    ],
    providers: [TranslatePipe],
})
export class TrainerComponent implements OnInit, AfterViewInit {
    private static _search = '';

    @ViewChild('searchInput')
    private searchInput: ElementRef;

    account: any;
    error: string;
    success: string;
    agencyFilter = 'Toutes les agences';
    active = true;
    trainers: Trainer[] = [];
    agencies: Location[] = [];
    availableLanguages: string[] = [];
    selectedLanguage = 'all';
    loadingTrainers = false;

    searchTrainersSubject = new BehaviorSubject<string>('');
    agencyFilterSubject = new BehaviorSubject<number | undefined>(undefined);

    filterMetadata = {
        countName: 0,
        countCan: 0,
        countGiven: 0,
        countWhised: 0,
        countFollowed: 0,
        countRefuse: 0,
    };

    constructor(
        private sessionService: SessionService,
        private graphQlService: GraphQlService
    ) {}

    get search(): string {
        return TrainerComponent._search;
    }

    set search(search: string) {
        TrainerComponent._search = search;
    }

    ngOnInit() {
        combineLatest([this.searchTrainersSubject, this.agencyFilterSubject])
            .pipe(
                filter(
                    ([keyword, agencyId]) => keyword.length >= 2 || !!agencyId
                ),
                tap(() => {
                    this.loadingTrainers = true;
                }),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap(([keyword, agencyId]) => {
                    return this.searchForTrainersByNameOrSkill(
                        keyword,
                        agencyId
                    );
                })
            )
            .subscribe((trainers) => {
                this.trainers = trainers;
                this.loadingTrainers = false;
            });
        this.sessionService
            .findAllLocations()
            .subscribe((agencies) => (this.agencies = agencies));
        this.fetchAvailableLanguages();
    }

    searchForTrainersByNameOrSkill(
        keyword: string,
        agencyId?: number
    ): Observable<Trainer[]> {
        return this.graphQlService
            .post({
                query: `
                query searchTrainers($keyword: String! $agencyId: bigint) {
                    trainers: search_trainers_by_name_or_skill(args: {
                        search: $keyword
                        location_id_filter: $agencyId
                    }) {
                        id
                        active
                        firstName: first_name
                        lastName: last_name
                        extended {
                            picturePath: picture_path
                        }
                        company {
                            name
                        }
                        trainerSkills: plt_trainer_skills {
                            can
                            followed
                            nbGiven: nb_given
                            wished
                            refuse
                            training {
                                title
                            }
                        }
                        languages: trainer_languages {
                            code: language_code
                        }
                    }
                }
            `,
                variables: {
                    keyword: keyword.trim(),
                    agencyId,
                },
                role: 'world',
            })
            .map((result) =>
                result.trainers
                    // this is to keep compatibility with trainer-card component
                    .map((trainer) => ({
                        ...trainer,
                        picturePath:
                            trainer.extended && trainer.extended.picturePath,
                        companyName: trainer.company.name,
                        trainerSkills: trainer.trainerSkills.map((skill) => ({
                            ...skill,
                            trainingName: skill.training.title,
                        })),
                    }))
            );
    }

    fetchAvailableLanguages() {
        this.graphQlService
            .post({
                query: `query getLanguages {
                        languages: language {
                            code
                        }
                     }`,
                variables: {},
                role: 'world',
            })
            .subscribe(({ languages }) => {
                this.availableLanguages = languages.map(
                    (language) => language.code
                );
            });
    }

    searchByNameOrSkill() {
        this.searchTrainersSubject.next(this.search);
    }

    activeClicked() {
        this.active = !this.active;
    }

    ngAfterViewInit(): void {
        this.searchInput.nativeElement.focus();
    }

    onAgencyFilterChange(agencyName) {
        const agency = this.agencies.find(
            (agency) => agency.name === agencyName
        );
        this.agencyFilterSubject.next(agency && agency.id);
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/trainer.component.ts